/** Default documents created for new users during registration. */

export const initialProfits = {
  profits: 0,
};

export const initialBalances = {
  signalBalance: 0,
  subscriptionBalance: 0,
  realEstateBalance: 0,
};
